import React from 'react';
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';
import MapEmbed from './MapEmbed';

// --- STYLED COMPONENTS ---

const SectionContainer = styled.section`
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 20px;
  color: #333333;
  line-height: 1.6;
`;

const HeaderArea = styled.div`
//   margin-bottom: 40px;
`;

const MainTitle = styled.h1`
  font-size: 2.2rem;
  font-weight: 700;
  color: #439E6D; /* Dark corporate navy blue */
//   margin: 0 0 8px 0;
`;

const Subtitle = styled.h2`
  font-size: 1.1rem;
  font-weight: 600;
  color: #439E6D; /* Your signature green theme accent color */
  text-transform: uppercase;
  letter-spacing: 0.5px;
//   margin: 0 0 20px 0;
`;

const IntroParagraph = styled.p`
  font-size: 0.95rem;
  color: #4a5568;
  text-align: justify;
//   margin: 0;
  max-width: 1150px;
`;

const OfficeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  margin-top: 10px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

const OfficeCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 320px;
  background-color: #ffffff;
`;

const CardTopContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const OfficeTitle = styled.h3`
  font-size: 1.35rem;
  font-weight: 700;
  color: #439E6D;
  text-transform: uppercase;
//   margin: 0 0 10px 0;
  line-height: 1.2;
  min-height: 50px; /* Aligns content if titles wrap lines */
  
  @media (max-width: 640px) {
    min-height: auto;
  }
`;

const AddressText = styled.p`
  font-size: 1.1rem;
  color: #4a5568;
//   margin: 0 0 15px 0;
`;

const PhoneText = styled.p`
  font-size: 1.1rem;
  font-weight: 600;
  color: #334155;
//   margin: 0 0 25px 0;
`;

const PitchText = styled.p`
  font-size: 1.1rem;
  color: #64748b;
  font-style: italic;
//   margin: 0 0 20px 0;
  line-height: 1.5;
`;

const EmailButton = styled.a`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  background-color: #64748b; /* Corporate slate gray button matching image */
  color: #ffffff;
  padding: 10px 18px;
  font-size: 1.1rem;
  font-weight: 500;
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;

  &::before {
    /* Custom CSS styled vector icon fallback mimicking the box envelope layout graphic */
    content: "✉";
    margin-right: 8px;
    font-size: 1rem;
  }

  &:hover {
    background-color: #475569;
  }
`;

// --- MAIN COMPONENT ---

const ContactUs = () => {
  return (
    <SectionContainer>
      {/* Header & Description */}
      <Fade triggerOnce direction="up" duration={800}>
        <HeaderArea>
          <MainTitle>Contact Us</MainTitle>
          <Subtitle>CIVIL ENGINEERING COMPANY</Subtitle>
          <IntroParagraph>
            A Civil Engineering Designs and Construction, Steel Fabrication and piping, Project Management, Engineering Technical Services, Maintenance, Procurement, Environmental services, Geographical information management, Onshore and Offshore surveying and positioning Services (including offshore sub-surface positioning, geophysical and geotechnical surveys), as well as Logistics Services.
          </IntroParagraph>
        </HeaderArea>
      </Fade>

      {/* Office Locations 3-Column Split */}
      <OfficeGrid>
        <Fade triggerOnce cascade direction="up" duration={600} fraction={0.1} damping={0.15}>
          
          {/* Column 1: Corporate Office */}
          <OfficeCard>
            <CardTopContent>
              <OfficeTitle>OUR CORPORATE OFFICE</OfficeTitle>
              <AddressText>Plot 13 C&C Layout, Off Nvuike (RD) Road, Mgbesilaru-Obio, Port-Harcourt</AddressText>
              <PhoneText>+234(0)8034579614, 0904 974 3886</PhoneText>
              <PitchText>Stay up-to-date and receive professional advice on specific regulatory requirements.</PitchText>
            </CardTopContent>
            {/* <EmailButton href="mailto:info@padecglobal.com">Email Us</EmailButton> */}
          </OfficeCard>

          {/* Column 2: Port Harcourt Main Office */}
          <OfficeCard>
            <CardTopContent>
              <OfficeTitle>OUR PORT HARCOURT MAIN OFFICE</OfficeTitle>
              <AddressText>23 B School Road, Rumuokwurusi, Port Harcourt</AddressText>
              <PhoneText>+234(0)8034579614, 0904 974 3886</PhoneText>
              <PitchText>Contract us on all your engineering, environmental services, geographical services, geographical and surveying services</PitchText>
            </CardTopContent>
            {/* <EmailButton href="mailto:ph@padecglobal.com">Email Us</EmailButton> */}
          </OfficeCard>

          {/* Column 3: Lagos Office */}
          <OfficeCard>
            <CardTopContent>
              <OfficeTitle>LAGOS</OfficeTitle>
              <AddressText>No 8 Ampton Close, Cadogan Estate, Lekki. Lagos State</AddressText>
              <PhoneText>+234(0)8034579614, 0904 974 3886</PhoneText>
              <PitchText>Contract us on all your engineering, environmental services, geographical and surveying services</PitchText>
            </CardTopContent>
            {/* <EmailButton href="mailto:lagos@padecglobal.com">Email Us</EmailButton> */}
          </OfficeCard>

        </Fade>
      </OfficeGrid>


      <MapEmbed
  embedUrl="https://www.google.com/maps?q=23+School+Rd,+Elelenwo,+Rivers+State&output=embed"
  address="23 School Rd, Elelenwo, Rivers State"
/>


    </SectionContainer>
  );
};

export default ContactUs;